import React from 'react'
import Moment from 'moment'

import createTouch from '../../actions/createTouch'
import lastTouchChoices from '../misc/lastTouchChoices'
import {
  Quiz,
  QuizQuestion,
  QuizAnswers,
  QuizAnswer,
} from '../../styles/quiz'

const LastTouchQuiz = ({person}) => (
  <Quiz>
    <QuizQuestion>How long has it been since you talked to {person.name}?</QuizQuestion>
    <QuizAnswers>
      {lastTouchChoices.map(opt => (
        <QuizAnswer key={opt.name} onClick={() => {
          const date = Moment().subtract(opt.days, 'days').toDate()
          createTouch({personId: person.id, date})      
        }}>
          {opt.name}
        </QuizAnswer>
      ))}
    </QuizAnswers>
  </Quiz>
)

export default LastTouchQuiz



// WEBPACK FOOTER //
// ./src/views/people/LastTouchQuiz.js